import React, {Component} from "react";

import ProjectFilter from "./ProjectFilter/ProjectFilter";
import ProjectGallery from "./ProjectGallery/ProjectGallery";

const categories = ["All", "LAMP", "React", "C#", "NodeJS", "Java", "Chrome"];

export default class Projects extends Component
{
	constructor()
	{
		super();
		this.state = {filter: categories[0]};

		this.onChangeFilter = this.onChangeFilter.bind(this);
	}

	onChangeFilter(filter)
	{
		this.setState({filter});
	}

	render()
	{
		return (
			<div>
				<ProjectFilter categories={categories} filter={this.state.filter} onChangeFilter={this.onChangeFilter} />
				<ProjectGallery filter={this.state.filter} />
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Home/Portfolio/Projects/Projects.js